<template>
  <layout class="page-awards">
    <div slot="banner"></div>
    <div class="empty-box"></div>

    <div class="finalist">
      <div class="layout-content">
        <div class="page-title">
          <img :src="isMobile ? data.introduction.mobileTitleImg : data.introduction.titleImg" alt="title" />
        </div>

        <div class="introduction">
          <div class="introduction-text">
            <p v-for="(p, index) in data.introduction.intro" :key="index" v-html="p"></p>
          </div>
          <div class="introduction-certificate">
            <img :src="isMobile ? data.introduction.mobileCertificate : data.introduction.certificate" alt="证书" />
            <p>「区块链数字证书」</p>
          </div>
        </div>

        <div class="introduction">
          <div class="introduction-text">
            <p v-for="(p, index) in data.introduction.introLast" :key="index" v-html="p"></p>
          </div>
        </div>

        <div class="title-wrap">
          <SubTitle :text="data.finalist.title" :subText="data.finalist.subTitle" />
        </div>

        <template v-if="isMobile">
          <ul class="finalist-list-wap">
            <li v-for="(item, index) in data.finalist.content" :key="item.alias">
              <div class="tag-wap" :on="openTag[index]" :data-type="item.alias" @click="handleToggleTag(index)">
                <IconWap :type="item.alias" :hover="openTag[index]" :color="item.color" />
                <span>{{item.title}}</span>
              </div>

              <template v-if="openTag[index]">
                <div class="list-item-wap" :key="i" v-for="(product, i) in item.list" :data-type="item.alias">
                  <div class="list-item-product">
                    <h6 :data-type="item.alias">{{product.product}}</h6>
                  </div>
                  <div class="line"></div>
                  <p data-label="队伍:">{{product.team}}</p>
                  <p data-label="成员:">{{product.member}}</p>
                  <p data-label="学校:">{{product.school}}</p>
                </div>
              </template>
            </li>
          </ul>
        </template>

        <template v-else>
          <ul class="finalist-tag-list">
            <li class="finalist-tag-item" :on="currentTag == index" v-for="(item, index) in data.finalist.content" :key="item.alias" :data-type="item.alias" @click="currentTag = index">
              <Icon :type="item.alias" :hover="currentTag == index" :color="item.color" />
              <span>{{item.title}}</span>
            </li>
          </ul>

          <ul class="list">
            <li :key="index" v-for="(item, index) in data.finalist.content[currentTag].list" :data-type="data.finalist.content[currentTag].alias">
              <h6 :data-type="data.finalist.content[currentTag].alias">{{item.product}}</h6>
              <div class="line"></div>
              <p data-label="队伍:">{{item.team}}</p>
              <p data-label="成员:">{{item.member}}</p>
              <p data-label="学校:">{{item.school}}</p>
            </li>
          </ul>
        </template>

      </div>
    </div>
  </layout>
</template>

<script>
import layout from '../../components/layout/layout'
import SubTitle from '../../components/SubTitle'
import Icon from './Icon.vue'
import IconWap from './IconWap.vue'

import { mapState } from 'vuex'

export default {
  name: 'Awards',

  components: {
    layout,
    SubTitle,
    Icon,
    IconWap
  },

  data () {
    return {
      currentTag: 0,
      openTag: {}
    }
  },

  computed: {
    ...mapState([
      'isMobile'
    ]),
    data () {
      return this.$t('awards')
    }
  },

  methods: {
    handleToggleTag (index) {
      this.$set(this.openTag, index, !this.openTag[index])
    }
  }
}
</script>

<style lang="scss" scoped>

.page-awards {
  background: $bgGrey;
}

.empty-box {
  width: 100vw; height: 81px;

  @include mobile {
    height: 55px;
  }
}

.finalist {
  padding: 86px 0 141px;
  background: $bgGrey;

  @include mobile {
    padding: 24px 0 75px;
  }

  .layout-content {
    position: relative;
    z-index: 10;
  }
}

.page-title {
  padding-bottom: 20px;

  & img {
    display: block;
    width: 759px; height: 196px;
  }

  @include mobile {
    padding-bottom: 4px;

    & img {
      width: 323px; height: 86px;
    }
  }
}

.introduction {
  display: flex;
  padding-top: 20px;
  color: #000;

  @include mobile {
    flex-direction: column;
    padding-top: 16px;
  }
}

.introduction-text {
  flex: 1;

  & p {
    padding-bottom: 20px;
    line-height: 35px;
    @include font(16);

    &:last-child {
      padding-bottom: 0;
    }

    @include mobile {
      padding-bottom: 16px;
      line-height: 28px;
      font-size: 14px;

      &:last-child {
        padding-bottom: 0;
      }
    }
  }
}

.introduction-certificate {
  padding-top: 10px; margin-left: 50px;

  & img {
    display: block;
    width: 314px; height: 232px;
  }

  & p {
    padding-top: 20px; margin: 0 auto;
    line-height: 24px;
    text-align: center;
    @include font(14);
    color: #888;
  }

  @include mobile {
    padding-top: 16px; margin-left: 0;

    & img {
      width: 100%; height: auto;
    }

    & p {
      padding-top: 12px;
      line-height: 22px;
      font-size: 12px;
    }
  }
}

.title-wrap {
  margin-top: 120px;

  @include mobile {
    margin-top: 50px;
  }
}

.finalist-tag-list {
  display: flex;
  height: 68px;
}

.finalist-tag-item {
  flex: 1 0 0 ;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 68px;
  background-color: #FFF;
  line-height: 1;
  font-size: 20px; font-weight: 500;
  color: #000;
  cursor: pointer;
  user-select: none;

  &[data-type="ai"][on] {
    background-color: #FEE7E5;
    color: #E1574D;
  }
  &[data-type="blockchain"][on] {
    background-color: #F2EDFF;
    color: #7652E1;
  }
  &[data-type="pm"][on] {
    background-color: #E7F2FF;
    color: #376EFD;
  }

  & span {
    margin-left: 6px;
  }
}

.list {
  display: grid;
  gap: 21px 20px;
  grid-template-columns: repeat(2, 1fr);
  padding-top: 20px;

  & > li {
    position: relative;
    box-sizing: border-box;
    overflow: hidden;
    position: relative;
    padding: 19px 16px 16px;
    background-color: #FFF;
    background-position: left top;
    background-repeat: no-repeat;
    background-size: 262px 112px;

    &[data-type="ai"] {
      background-image: url('../../assets/img/awards/box-bg-top-ai.png');
    }
    &[data-type="blockchain"] {
      background-image: url('../../assets/img/awards/box-bg-top-blockchain.png');
    }
    &[data-type="pm"] {
      background-image: url('../../assets/img/awards/box-bg-top-pm.png');
    }

    &:before {
      content: '';
      display: block;
      position: absolute; right: 0; top: 0;
      width: 24px; height: 31px;
      background: url('../../assets/img/awards/box-arrow.png');
      background-size: contain;
    }

    &:after {
      content: '';
      display: block;
      position: absolute; right: 0; bottom: 0;
      width: 82px; height: 82px;
      background-size: contain;
      pointer-events: none;
    }

    &[data-type="ai"]:after {
      background-image: url('../../assets/img/awards/box-bg-icon-ai.png');
    }
    &[data-type="blockchain"]:after {
      background-image: url('../../assets/img/awards/box-bg-icon-blockchain.png');
    }
    &[data-type="pm"]:after {
      background-image: url('../../assets/img/awards/box-bg-icon-pm.png');
    }
  }

  & h6 {
    position: relative;
    height: 50px;
    line-height: 25px;
    @include font(18, 500);
    color: #000;

    &:before {
      content: '';
      display: block;
      position: absolute; left: -16px; top: 4px;
      width: 4px; height: 14px;
    }

    &[data-type="ai"]:before {
      background-color: #EC664F;
    }
    &[data-type="blockchain"]:before {
      background-color: #7652E1;
    }
    &[data-type="pm"]:before {
      background-color: #376EFD;
    }
  }

  & .line {
    width: 100%; height: 36px;
    background: url('../../assets/img/awards/line.png') repeat-x 3px 18px/189px 2px;
  }

  & p {
    position: relative; z-index: 1;
    padding: 0 0 10px 44px;
    line-height: 22px;
    @include font(15, 500);
    color: rgba(0, 0, 0, 0.7);

    &:last-child {
      padding-bottom: 0;
    }

    &:before {
      content: attr(data-label);
      display: block;
      position: absolute; left: 0; top: 0;
      line-height: 21px;
      @include font(15);
      color: rgba(0, 0, 0, 0.6);
    }
  }
}

.finalist-list-wap {
  padding-top: 4px;
}

.tag-wap {
  position: relative;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  height: 54px;
  padding-left: 14px; margin-bottom: 12px;
  background-color: #FFF;
  line-height: 1;
  font-size: 16px; font-weight: 500;
  color: #000;
  cursor: pointer;
  user-select: none;

  &:after {
    content: '';
    display: block;
    position: absolute; right: 14px; top: calc(50% - 8px);
    width: 16px; height: 16px;
    background: url('../../assets/img/awards/closed-icon.png');
    background-size: contain;
    pointer-events: none;
  }

  &[on]:after {
    background-image: url('../../assets/img/awards/opened-icon.png');
  }

  &:active {
    background-color: transparent;
  }

  &[data-type="ai"][on] {
    color: #E1574D;
  }
  &[data-type="blockchain"][on] {
    color: #7652E1;
  }
  &[data-type="pm"][on] {
    color: #376EFD;
  }

  & span {
    margin-left: 6px;
  }
}

.list-item-wap {
  position: relative;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  padding: 0 20px 22px; margin-bottom: 12px;
  background-color: #FFF;
  background-position: left top;
  background-repeat: no-repeat;
  background-size: 262px 112px;

  &[data-type="ai"] {
    background-image: url('../../assets/img/awards/box-bg-top-ai.png');
  }
  &[data-type="blockchain"] {
    background-image: url('../../assets/img/awards/box-bg-top-blockchain.png');
  }
  &[data-type="pm"] {
    background-image: url('../../assets/img/awards/box-bg-top-pm.png');
  }

  &:before {
    content: '';
    display: block;
    position: absolute; right: 0; top: 0;
    width: 31px; height: 22px;
    background: url('../../assets/img/awards/box-arrow-wap.png');
    background-size: contain;
  }

  &:after {
    content: '';
    display: block;
    position: absolute; right: 0; bottom: 0;
    width: 62px; height: 62px;
    background-size: contain;
    pointer-events: none;
  }

  &[data-type="ai"]:after {
    background-image: url('../../assets/img/awards/box-bg-icon-ai.png');
  }
  &[data-type="blockchain"]:after {
    background-image: url('../../assets/img/awards/box-bg-icon-blockchain.png');
  }
  &[data-type="pm"]:after {
    background-image: url('../../assets/img/awards/box-bg-icon-pm.png');
  }

  & .line {
    width: 100%; height: 20px;
    background: url('../../assets/img/awards/line-wap.png') repeat-x center top/189px 2px;
  }

  & p {
    position: relative; z-index: 1;
    padding: 0 0 8px 44px;
    line-height: 20px;
    @include font(13, 500);
    color: rgba(0, 0, 0, 0.7);

    &:last-child {
      margin-bottom: 0;
    }

    &:before {
      content: attr(data-label);
      display: block;
      position: absolute; left: 0; top: 0;
      line-height: 21px;
      @include font(13);
      color: rgba(0, 0, 0, 0.6);
    }
  }
}

.list-item-product {
  display: flex;
  align-items: center;
  height: 108px;

  & h6 {
    position: relative;
    line-height: 24px;
    @include font(16, 500);
    color: #000;

    &:before {
      content: '';
      display: block;
      position: absolute; left: -20px; top: 6px;
      width: 4px; height: 14px;
    }

    &[data-type="ai"]:before {
      background-color: #EC664F;
    }
    &[data-type="blockchain"]:before {
      background-color: #7652E1;
    }
    &[data-type="pm"]:before {
      background-color: #376EFD;
    }
  }
}
</style>
